module.exports = __webpack_public_path__ + "static/logo-78d2063bcc5e542bf67195e3c6fb6fcf.svg";